"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("../../../theme/styled"));

var emotion_theming_1 = require("emotion-theming");

var react_1 = __importDefault(require("react"));

var InnerCollection = styled_1["default"].div(function (_ref) {
  var justify = _ref.justify,
      hSpace = _ref.hSpace,
      vSpace = _ref.vSpace;
  return {
    display: 'flex',
    flexWrap: 'wrap',
    margin: "-".concat(vSpace, "px 0 0 -").concat(hSpace, "px"),
    justifyContent: "".concat(justify === 'start' || justify === 'full' ? 'flex-start' : justify === 'center' ? 'center' : 'flex-end')
  };
});
var InnerItem = styled_1["default"].div(function (_ref2) {
  var justify = _ref2.justify,
      hSpace = _ref2.hSpace,
      vSpace = _ref2.vSpace;
  return {
    margin: "".concat(vSpace, "px 0 0 ").concat(hSpace, "px"),
    flex: justify === 'full' ? 'auto' : 'initial',
    display: 'flex'
  };
});
var JustifyInnerItem = styled_1["default"].div(function (_ref3) {
  var _ref3$verticalJustify = _ref3.verticalJustify,
      verticalJustify = _ref3$verticalJustify === void 0 ? 'start' : _ref3$verticalJustify;
  return {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    marginTop: verticalJustify === 'end' || verticalJustify === 'center' ? 'auto' : 0,
    marginBottom: verticalJustify === 'start' || verticalJustify === 'center' ? 'auto' : 0
  };
});

var Collection = function Collection(_ref4) {
  var className = _ref4.className,
      children = _ref4.children,
      theme = _ref4.theme,
      _ref4$hSpace = _ref4.hSpace,
      hSpace = _ref4$hSpace === void 0 ? 0 : _ref4$hSpace,
      _ref4$vSpace = _ref4.vSpace,
      vSpace = _ref4$vSpace === void 0 ? 0 : _ref4$vSpace,
      _ref4$justify = _ref4.justify,
      justify = _ref4$justify === void 0 ? 'start' : _ref4$justify,
      verticalJustify = _ref4.verticalJustify;
  var actualHSpace = theme.space ? theme.space[hSpace] : 0;
  var actualVSpace = theme.space ? theme.space[vSpace] : 0;
  return react_1["default"].createElement("div", {
    className: className
  }, react_1["default"].createElement(InnerCollection, {
    hSpace: actualHSpace,
    vSpace: actualVSpace,
    justify: justify
  }, react_1["default"].Children.map(children, function (child) {
    return react_1["default"].createElement(InnerItem, {
      hSpace: actualHSpace,
      vSpace: actualVSpace,
      justify: justify
    }, react_1["default"].createElement(JustifyInnerItem, {
      verticalJustify: verticalJustify
    }, child));
  })));
};

exports["default"] = emotion_theming_1.withTheme(Collection);